import consola, { LogLevel } from 'consola';

export const logger = consola.create({
  level: process.env.ENV === 'production' ? LogLevel.Silent : LogLevel.Debug,
});
